<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom card-stretch" id="page">
          <!--begin::Header-->
          <div class="card-header align-items-center px-4 py-3">
            <div class="flex-grow-1">
              <div class="text-dark-75 font-weight-bold font-size-h5">
                {{ client.fullName }}
              </div>
            </div>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div class="card-body">
            <!--begin::Scroll-->
            <div class="card-scroll">
              <!--begin::Messages-->
              <div class="messages" id="messages">
                <div
                  class="d-flex flex-column mb-5 mr-5"
                  :class="{
                    'align-items-start': !message.sentByMe,
                    'align-items-end': message.sentByMe,
                  }"
                  v-for="message in discussion.messages"
                  :key="message.guid"
                >
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-circle symbol-40 mr-3">
                      <i class="fas fa-user fs-10"></i>
                    </div>
                    <div>
                      <a
                        class="text-dark-75 text-hover-primary font-weight-bold font-size-h6 mr-2"
                        >{{ message.sender.userName }}</a
                      >
                      <span class="text-muted font-size-sm">
                        <timeago
                          :datetime="message.createdAtUtc"
                          :auto-update="60"
                        ></timeago
                      ></span>
                    </div>
                  </div>
                  <div
                    class="mt-2 rounded p-5 text-dark-50 font-weight-bold font-size-lg text-left max-w-400px"
                    :class="{
                      'bg-light-success': !message.sentByMe,
                      ' bg-light-primary': message.sentByMe,
                    }"
                    style="white-space: pre-line; "
                  >
                    {{ message.content }}
                  </div>
                </div>
              </div>
              <!--end::Messages-->
            </div>
            <!--end::Scroll-->
          </div>
          <!--end::Body-->

          <!--begin::Footer-->
          <div class="card-footer align-items-center">
            <!--begin::Compose-->
            <textarea
              class="form-control"
              rows="2"
              placeholder="Message"
              v-model="message.content"
              @keydown.enter.exact.prevent="sendMessage()"
              @keydown.enter.shift.exact.prevent="message.content += '\n'"
            ></textarea>
            <div class="d-flex align-items-center justify-content-between mt-5">
              <div class="mr-3"></div>
              <div>
                <b-overlay :show="isLoading" rounded="sm">
                  <button
                    type="button"
                    class="btn btn-primary btn-md text-uppercase font-weight-bold chat-send py-2 px-6"
                    @click="sendMessage()"
                  >
                    Envoyer
                  </button>
                </b-overlay>
              </div>
            </div>
            <!--begin::Compose-->
          </div>
          <!--end::Footer-->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.messages {
  height: 400px;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
  scroll-behavior: smooth;
}
</style>
<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import clientsService from "../../../services/clients.service";

//import SearchApiService from "../../../core/services/searchapi.service";
//import JwtService from "../../../core/services/jwt.service";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "detail",
  components: {},
  data() {
    return {
      client: {},
      discussion: { sender: {}, message: [] },
      message: { content: "" },
      isLoading: false,
    };
  },
  validations: {
    quote: {
      amount: {
        required,
      },
    },
    cancel: {
      motiveGuid: {
        required,
      },
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getClient(to.params.guid);
    next();
  },
  created() {
    this.$availabilityHub.$on("message-notify", this.refresh);
  },
  beforeDestroy() {
    this.$availabilityHub.$off("message-notify", this.refresh);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Clients" },
      { title: "Messages" },
      { title: "Detail" },
    ]);

    this.getMessages(this.$route.params.guid);
    this.getClient(this.$route.params.guid);
  },
  methods: {
    refresh: function(notif) {
      if (notif.senderId == this.$route.params.guid)
        this.getMessages(this.$route.params.guid);
    },
    getClient: function (guid) {
      clientsService.getClient(guid).then((result) => {
        this.client = result.data;
      });
    },
    getMessages: function(guid) {
      clientsService.getMessages(guid).then((result) => {
        this.discussion = result.data;
        setTimeout(() => {
          const messagesContainer = document.getElementById("messages");
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }, 200);
      });
    },

    sendMessage: function() {
      if (this.message.content.trim().length == 0 || this.isLoading) return;

      this.isLoading = true;
      clientsService
        .sendMessages({
          content: this.message.content,
          clientId: this.$route.params.guid,
        })
        .then(() => {
          this.isLoading = false;
          this.getMessages(this.$route.params.guid);
          this.message.content = "";
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
